import { render, staticRenderFns } from "./common-service.vue?vue&type=template&id=4d0a8df3&scoped=true"
import script from "./common-service.vue?vue&type=script&lang=js"
export * from "./common-service.vue?vue&type=script&lang=js"
import style0 from "./common-service.vue?vue&type=style&index=0&id=4d0a8df3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0a8df3",
  null
  
)

export default component.exports